import styled, { css } from 'styled-components';
import { mq } from '~/styles/grid';
import getSpacing from '~/helpers/getSpacing';

import { CopyTextBasicStyling } from '~/components/atoms/Copytext/Copytext.styles';
import SafeHTML from '~/components/atoms/SafeHTML';

export const TitleBasicCss = css`
  color: ${(props) => props.theme.color.primary800};
  font-family: ${(props) => props.theme.font.bold};
  font-size: ${(props) => props.theme.jobDetail.titleFontSize}px;
`;

const Wrapper = styled.div`
  margin-bottom: 45px;

  @media (${mq.mdDown}) {
    padding: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Title = styled.h2`
  ${TitleBasicCss};
  margin-bottom: 15px;

  &:first-letter {
    text-transform: capitalize;
  }
`;

const Details = styled.div`
  ${CopyTextBasicStyling};

  h1,
  h2,
  h3,
  h4,
  h5 {
    ${TitleBasicCss};
  }

  ul + ul {
    ${(props) => getSpacing(props.theme.spacingMap.richtext.li, 'mtop')};
  }

  ul li {
    &:before {
      top: 11px;
      background: ${(props) => props.theme.color.gray600};
      height: 4px;
      width: 4px;
    }
  }
`;

/**
 * @param {DescriptionDetailProps} props
 * @returns {React.ReactElement} The rendered component
 */
const DescriptionDetail = ({ value, title }) => {
  return (
    <Wrapper>
      {title && title !== '' && <Title>{title}</Title>}

      <SafeHTML as={Details} html={value} />
    </Wrapper>
  );
};

export default DescriptionDetail;
